import { createRouter, createWebHistory, createWebHashHistory } from 'vue-router';
import form from './form';
import formsMulti from './formsMulti';
import tables from './tables';
import viewgird from './viewGird';
import store from '../store/index';
import redirect from './redirect';
import charts from './charts';
import runtimeConfig from '@/api/runtimeConfig';
import http from '@/api/http';
const routes = [
  {
    path: '/',
    name: 'Index',
    component: () => import('@/views/Index'),
    // 回首页
    // redirect: '/home',
    // redirect: '/MapView',
    redirect: (to) => {
      return runtimeConfig.homePath;
    },
    children: [
      ...form, //Demo表单路由
      ...formsMulti,
      ...tables, //tables
      ...viewgird,
      ...redirect,
      ...charts,
      {
        path: '/home',
        name: 'home',
        component: () => import('@/views/Home.vue')
      },
      {
        path: '/UserInfo',
        name: 'UserInfo',
        component: () => import('@/views/system/UserInfo.vue')
      },
      {
        path: '/sysMenu',
        name: 'sysMenu',
        component: () => import('@/views/system/Sys_Menu.vue')
      },
      {
        path: '/coder',
        name: 'coder',
        component: () => import('@/views/builder/coder.vue')
      },
      {
        path: '/formDraggable', //表单设计
        name: 'formDraggable',
        component: () => import('@/views/formDraggable/formDraggable.vue')
      },
      {
        path: '/formSubmit', //表单提交页面
        name: 'formSubmit',
        component: () => import('@/views/formDraggable/FormSubmit.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/formCollectionResultTree', //显示收集的数据表单
        name: 'formCollectionResultTree',
        component: () => import('@/views/formDraggable/FormCollectionResultTree.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/signalR',
        name: 'signalR',
        component: () => import('@/views/signalR/Index.vue'),
        meta: {
          keepAlive: false
        }
      },
      {
        path: '/flowdemo', //发起流程示例
        name: 'flowdemo',
        component: () => import('@/views/system/flow/FlowDemo.vue'),
        meta: {
          keepAlive: false
        }
      }
    ]
  },
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/Login.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/MetCompMenu',
    name: 'MetCompMenu',
    component: () => import('@/views/method/method/MetCompMenu.vue')
  },
  {
    path: '/RoomBoard',
    name: 'RoomBoard',
    component: () => import('@/views/method/method/RoomBoard.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/Dev_Report',
    name: 'Dev_Report',
    component: () => import('@/views/device/energy/Dev_Report.vue')
  },
  {
    path: '/Dev_EnergyStorageReport',
    name: 'Dev_EnergyStorageReport',
    component: () => import('@/views/device/energy/Dev_EnergyStorageReport.vue')
  },
  {
    path: '/Dev_LineGraph2',
    name: 'Dev_LineGraph2',
    component: () => import('@/views/device/energy/Dev_LineGraph2.vue')
  },
  {
    path: '/Dev_LineGraph3',
    name: 'Dev_LineGraph3',
    component: () => import('@/views/device/energy/Dev_LineGraph3.vue')
  },
  {
    path: '/Dev_LineGraphView2',
    name: 'Dev_LineGraphView2',
    component: () => import('@/views/device/energy/Dev_LineGraphView2.vue')
  },
  {
    path: '/Dev_LineGraphView3',
    name: 'Dev_LineGraphView3',
    component: () => import('@/views/device/energy/Dev_LineGraphView3.vue')
  },
  {
    path: '/KanbanBoard',
    name: 'KanbanBoard',
    component: () => import('@/views/device/DeviceMonitor/KanBan.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/EnergyDashBoard',
    name: 'EnergyDashBoard',
    component: () => import('@/views/device/energy/Dashboard/EnergyDashBoard.vue'),
    meta: {
      anonymous: true
    }
  },
  {
    path: '/MetCompMenuView',
    name: 'MetCompMenuView',
    component: () => import('@/views/method/method/MetCompMenuView.vue'),
    meta: {
      anonymous: true
    },
    children: [
      {
        path: 'MetDashboard',
        name: 'MetDashboard',
        component: () => import('@/views/method/method/MetDashboard.vue'),
        meta: {
          anonymous: true
        }
      },
      {
        path: 'MapViewNew',
        name: 'MapViewNew',
        component: () => import('@/views/method/method/MapViewNew.vue'),
        meta: {
          anonymous: true
        }
      }
    ]
  },
  {
    path: '/app/guide',
    name: 'apphome',
    meta: {
      anonymous: true
    },
    component: () => import('@/views/h5/Guide.vue')
  },
  {
    path: '/bigdata',
    name: 'bigdata',
    component: () => import('@/views/charts/bigdata.vue'),
    meta: {
      keepAlive: false
    }
  }
];

const router = createRouter({
  history: createWebHashHistory(), //createWebHistory(process.env.BASE_URL),
  routes
});

// sso登录:shaun:2025-10-23
router.beforeEach((to, from, next) => {
  if (to.matched.length == 0) return next({ path: '/404' });
  //2020.06.03增加路由切换时加载提示
  store.dispatch('onLoading', true);
  const isAnonymous = to.matched.some((r) => r.meta && r.meta.anonymous);
  const isSsoCallback = to.matched.some((r) => r.path === '/sso/callback' || r.name === 'ssoCallback');

  // 如果启用认证中心登录
  if (runtimeConfig.authType) {
    // 访问客户端 /login 时统一跳到 SSO 登录页，实现单点登录
    if (to.path === '/login') {
      const url = `${runtimeConfig.authBase}#/login?client_id=${encodeURIComponent(runtimeConfig.clientId)}&redirect_uri=${encodeURIComponent(runtimeConfig.redirectUri)}`;
      window.location.href = url;
      return;
    }

    if (isAnonymous || isSsoCallback || store.getters.isLogin()) {
      return next();
    }

    // 未登录且非匿名页面，跳转到 SSO 登录
    const url = `${runtimeConfig.authBase}#/login?client_id=${encodeURIComponent(runtimeConfig.clientId)}&redirect_uri=${encodeURIComponent(runtimeConfig.redirectUri)}`;
    window.location.href = url;
  } else {
    // 使用本地登录
    if (isAnonymous || store.getters.isLogin()) {
      return next();
    }
    // 未登录且非匿名页面，跳转到本地登录
    next({ path: '/login', query: { redirect: to.fullPath } });
  }
});
router.afterEach((to, from) => {
  store.dispatch('onLoading', false);
});
router.onError((error) => {
  // const targetPath = router.currentRoute.value.matched;
  try {
    console.log(error.message);
    if (process.env.NODE_ENV == 'development') {
      alert(error.message);
    }
    localStorage.setItem('route_error', error.message);
  } catch (e) {}
  window.location.href = '/';
});
export default router;
